<div class="createAudit">
  <p-dialog header="Header"
            (onHide)="dialogClose()"
            [modal]="true"
            [(visible)]="isHeaderVisible"
            [style]="{width: '35.5rem'}">
    <ng-template pTemplate="header">
      <div class="d-flex align-items-center" [style]="{paddingBottom: '0px'}">
        <div class="left-border left-border-bg"></div>
        <div class="d-flex-d-column margin-left-5">
          <span class="user-title-text">{{ title }}</span>
        </div>
      </div>
    </ng-template>
    <p-divider></p-divider>

    <div>
      <p class="para-text">
        {{ displayMessage }}
      </p>
      <p-divider></p-divider>
    </div>

    <!-- Bottom buttons -->
    <div class="btn-box" *ngIf="isShowButton">
      <!-- Create button -->
      <p-button [loading]="false"
                class="filled-btn"
                [label]="buttonText"
                (onClick)="buttonClickCallback()"
                severity="secondary"></p-button>
    </div>
  </p-dialog>
</div>
